/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cli_1_DescInputs */

const en_mk_cli_1_desc = /** @type {(inputs: Mk_Cli_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install the CLI from the computer guide. Connect projects, start or monitor a team, send guidance, stop, and resume workflows from your terminal.`)
};

const id_mk_cli_1_desc = /** @type {(inputs: Mk_Cli_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasang CLI dari panduan komputer. Hubungkan proyek, mulai atau pantau tim, kirim arahan, hentikan, dan lanjutkan workflow lewat terminal.`)
};

/**
* | output |
* | --- |
* | "Install the CLI from the computer guide. Connect projects, start or monitor a team, send guidance, stop, and resume workflows from your terminal." |
*
* @param {Mk_Cli_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cli_1_desc = /** @type {((inputs?: Mk_Cli_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cli_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cli_1_desc(inputs)
	return en_mk_cli_1_desc(inputs)
});